// extracted by mini-css-extract-plugin
export var centerText = "_68-8";
export var container = "_68-0";
export var doughnutContainer = "_68-7";
export var legend = "_68-a";
export var legendItemColorDisplay = "_68-b";
export var legendItemLabel = "_68-d";
export var legendItemValue = "_68-c";
export var lg = "_68-5";
export var maxWidth = "_68-9";
export var md = "_68-4";
export var responsive = "_68-6";
export var sm = "_68-3";
export var xs = "_68-2";
export var xxs = "_68-1";